import React, { useMemo, useEffect, useState } from "react";
import FirstBlock from "./MainPageComponents.js/FirstBlock";
import PerfumeBlock from "./MainPageComponents.js/PerfumeBlock";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";
import { useAppContext } from "../AppContext";
import axios from "axios";

// Simple skeleton component
const SkeletonLoader = () => (
  <div style={{ padding: "20px" }}>
    {[1, 2, 3, 4, 5, 6].map((item) => (
      <div
        key={item}
        style={{
          background:
            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.5s infinite",
          height: "300px",
          marginBottom: "20px",
          borderRadius: "8px",
        }}
      />
    ))}
    <style>
      {`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}
    </style>
  </div>
);

export default function MainPage() {
  const { AllData, setAllData } = useAppContext();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  const { t, i18n } = useTranslation();
  const [Loading, setLoading] = useState(true);
  const [Error, setError] = useState(null);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${MyDomain}Products/GetMainPageProducts`);
      setAllData(res.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const FirstBlockMemo = useMemo(() => <FirstBlock />, []);
  const PerfumeBlockMemo1 = useMemo(
    () => <PerfumeBlock CatCall={"Perfume"} />,
    []
  );
  const PerfumeBlockMemo3 = useMemo(
    () => <PerfumeBlock CatCall={"Womens bags"} />,
    []
  );
  const PerfumeBlockMemo4 = useMemo(
    () => <PerfumeBlock CatCall={"Womens wallet"} />,
    []
  );
  const PerfumeBlockMemo5 = useMemo(
    () => <PerfumeBlock CatCall={"Set bags"} />,
    []
  );
  const PerfumeBlockMemo6 = useMemo(
    () => <PerfumeBlock CatCall={"Womens watches"} />,
    []
  );
  const PerfumeBlockMemo9 = useMemo(
    () => <PerfumeBlock CatCall={"Accessories"} />,
    []
  );

  if (Error) {
    return (
      <div style={{ padding: "40px", textAlign: "center", color: "#d32f2f" }}>
        <h2>Error loading products</h2>
        <p>{Error}</p>
        <button
          onClick={fetchData}
          style={{ marginTop: "20px", padding: "10px 20px" }}
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {Loading ? (
        <SkeletonLoader />
      ) : (
        <>
          {FirstBlockMemo}
          {PerfumeBlockMemo1}
          {PerfumeBlockMemo3}
          {PerfumeBlockMemo4}
          {PerfumeBlockMemo5}
          {PerfumeBlockMemo6}
          {PerfumeBlockMemo9}
        </>
      )}
    </div>
  );
}
